import React, { useState } from 'react'
import styled from 'styled-components'
import StatementStatBar from './statement-stat-bar'
import Button from './button'
import DistributionChart from './distributionChart'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { TABLET, LAPTOP } from '../../utilities/breakpoints'
import { toNormalizedRespondentFilters } from '../../utilities/helpers'

const ANSWER_DISTRIBUTION = gql`
  query AnswerDistributions(
      $surveyId: UUID!
      $questionId: UUID!
      $respondentFilters: [RespondentFilterInput!]
  ) {
      answerDistribution( 
        surveyId: $surveyId
        questionId: $questionId
        respondentFilters: $respondentFilters
      ) {
          result {
              label
              count
          }
          importance {
              label
              count
          }
      }
  }
`;

const StatementStatBarWithDistribution = ({
  surveyId,
  showDistribution,
  filters,
  questionId,
  result,
  useTranslate,
  size="lg"
}) => {
  const [showCharts, setShowCharts] = useState(false);

  return (
    <ResultContainer>
      <BarContainer size={size}>
        <StatementStatBar result={result} useTranslate={useTranslate} size={size} />
        {result !== null && showDistribution &&
          <Button
            size={"sm"}
            kind={"gray"}
            onClick={() => setShowCharts(!showCharts)}
          >
            {showCharts ? `${useTranslate('data_vault.hide_distribution')} -` : `${useTranslate('data_vault.show_distribution')} +`}
          </Button>
        }
      </BarContainer>
      {showCharts &&
        <Query
          query={ANSWER_DISTRIBUTION}
          variables={{ surveyId, questionId, respondentFilters: toNormalizedRespondentFilters(filters) }}
          errorPolicy={"ignore"}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return null;
            }
            if (error) {
              console.warn("Error", error);

              return (
                <LoadingError>
                  Could not load data.
                </LoadingError>
              );
            }

            const {
              answerDistribution: { result, importance }
            } = data;

            return (
              <DistributionContainer>
                <DistributionChart
                  chartData={result}
                  chartType={"result"}
                  title={`${useTranslate("data_vault.current_state")} (n)`}
                />
                <Separator />
                <DistributionChart
                  chartData={importance}
                  chartType={"importance"}
                  title={`${useTranslate("data_vault.importance")} (n)`}
                />
              </DistributionContainer>
            )
          }}
        </Query>
      }
    </ResultContainer>
  )
}

export default StatementStatBarWithDistribution;

const ResultContainer = styled.div``;

const BarContainer = styled.div`
  .statement-stat-bar {
    margin-bottom: 12px;
  }
  
  .engager-btn {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 162px;
    height: ${({ size }) => size === "lg" ? '42px' : '36px'};
    padding: 0px 20px;
  }
  
  @media${LAPTOP} {
    display: flex;
    align-items: center;
    
    .statement-stat-bar {
      flex: 0 1 100%;
      margin-bottom: 0;
    }
    .engager-btn {
      width: auto;
      margin-left: 1.5rem;
      flex-shrink: 0;
    }
  }
`;

const DistributionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 30px 0;
  margin: 0 auto;
  
  @media${TABLET} {
    flex-direction: row;
    max-width: 630px;
  }
  
  @media${LAPTOP} {
    gap: 70px;
    max-width: 700px;
  }
`;

const Separator = styled.div`
  display: none;
  
  @media${TABLET} {
    display: block;
    height: 142px;
    width: 0px;
    border-left: 1px dashed #5F7D95;
  }

`;

const LoadingError = styled.div`
  text-align: center;
  padding: 40px 40px 20px;
  color: #5F7D95;
`;


// WEBPACK FOOTER //
// ./src/components/ui/statement-stat-bar-with-distribution.js